import { collection, query, where, getDocs, doc, setDoc, deleteDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/config';

/**
 * FCM 토큰을 Firestore에 저장
 */
export const saveFcmToken = async (uid, token, platform = 'android') => {
  if (!uid || !token) return;
  const tokenId = `${uid}_${platform}`;
  await setDoc(doc(db, 'fcmTokens', tokenId), {
    uid,
    token,
    platform,
    updatedAt: serverTimestamp(),
  });
};

/**
 * 사용자의 FCM 토큰 삭제 (로그아웃 시)
 */
export const removeFcmToken = async (uid) => {
  if (!uid) return;
  const q = query(collection(db, 'fcmTokens'), where('uid', '==', uid));
  const snap = await getDocs(q);
  for (const d of snap.docs) {
    await deleteDoc(d.ref);
  }
};
